import axios from 'axios';
import {
	ADD_TO_CART,
	REMOVE_FROM_CART,
	GET_CART_SUCCESS,
	UPDATE_CART_ITEM_QUANTITY,
	SET_ALERT,
} from './index';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const AddItemToCart = (item) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		await axios.post(
			BASE_URL + '/api/add-item',
			{ item: item.product_id, quantity: item.quantity || 1, variant_id: item.variant_id || null },
			config
		);
		dispatch({ type: ADD_TO_CART, payload: item });
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Item Successfully added in cart', status: 'success' },
		});
		return true;
	} catch (e: any) {
		dispatch({
			type: SET_ALERT,
			payload: {
				message: e.response?.data?.error || 'Failed to add item in cart',
				status: 'error',
			},
		});
		return false;
	}
};

export const getUserCart = () => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.get(BASE_URL + '/api/get-cart', config);
		dispatch({ type: GET_CART_SUCCESS, payload: response.data });
	} catch (e) {
		console.log(e);
	}
};

export const updateCartItemQuantity = (product_id: number, quantity: number, variant_id?: number | null) => async (dispatch: any) => {
	const config = { headers: { 'x-auth-token': localStorage.getItem('x-auth-token') } };
	try {
		await axios.put(BASE_URL + '/api/update-item', { product_id, quantity, variant_id: variant_id || null }, config);
		dispatch({ type: UPDATE_CART_ITEM_QUANTITY, payload: { product_id, quantity, variant_id } });
	} catch (e) {
		dispatch({ type: SET_ALERT, payload: { message: 'Failed to update quantity', status: 'error' } });
	}
};

export const removeItemFromCart = (product_id: number, variant_id?: number | null) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const url = variant_id
			? BASE_URL + `/api/delete-item?product_id=${product_id}&variant_id=${variant_id}`
			: BASE_URL + `/api/delete-item?product_id=${product_id}`;
		await axios.delete(url, config);
		dispatch({ type: REMOVE_FROM_CART, payload: { product_id, variant_id } });
	} catch (e) {
		console.log(e);
	}
};
